import { render, staticRenderFns } from "./RePass.vue?vue&type=template&id=45f7c692&scoped=true&"
import script from "./RePass.vue?vue&type=script&lang=js&"
export * from "./RePass.vue?vue&type=script&lang=js&"
import style0 from "./RePass.vue?vue&type=style&index=0&id=45f7c692&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f7c692",
  null
  
)

export default component.exports